module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "title-part"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429988070_toc01#toctitle5",
      "id": "title5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Two")])])])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_vm._v("Anthropologist Godfrey Lienhardt describes the animistic understanding of the Dinka tribe in the Sudan. A Dinka believes his own memories and daydreams to be external to himself, as external as the hills, and quick with substance. A man who was imprisoned in Khartoum named his infant daughter Khartoum in order to placate Khartoum, which seized him from time to time vividly. He believed that as he walked about his village, Khartoum itself, the city with its prison, overwhelmed him with the force of its presence.")])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—ANNIE DILLARD, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("THE WRITING LIFE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f8bf0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429988070_p02.vue
// module id = 84
// module chunks = 0